import styled from 'styled-components';

import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';

export const NavLink = styled.span<{ $isActive?: boolean }>`
  ${({ $isActive }) => ($isActive ? StyledTypo.uiTextBoldCss : StyledTypo.uiTextCss)};
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 4px 0;
  border-bottom: 2px solid ${({ $isActive }) => ($isActive ? Color.Blue_500_Ultramarine : 'transparent')};
  opacity: ${({ $isActive, theme }) => ($isActive ? 1 : theme.textOpacity)};
  transition: opacity ${({ theme }) => theme.transitionTiming};
`;

export const ClickArea = styled.a<{ ref: any }>`
  display: inline-block;
  padding: 8px;
  margin: -8px;

  &:hover {
    text-decoration: none;

    ${NavLink} {
      opacity: 1;
    }
  }
`;
